/*
 * Copyright (c) 2022-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'
import { Permission } from './Permission.js'
import { Role } from './Role.js'

export const TokenResponse = z.object({
  access_token: z.string(),
  display_name: z.string().nullish(),
  expires_in: z.number().int(),
  first_name: z.string().nullish(),
  id_expires_in: z.number().int().nullish(),
  id_token: z.string().nullish(),
  last_name: z.string().nullish(),
  organization_id: z.string().nullish(),
  permissions: z.array(Permission).nullish(),
  refresh_expires_in: z.number().int().nullish(),
  refresh_token: z.string().nullish(),
  roles: z.array(Role).nullish(),
  scope: z.string().nullish(),
  token_type: z.string(),
  user_id: z.string().nullish()
})

export interface TokenResponse extends z.TypeOf<typeof TokenResponse> {}
